import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const adminCards = [
  { title: "Blogs", desc: "Manage blog posts", icon: "FileText", path: "../admin/blogs" },
  { title: "Plans", desc: "Manage pricing plans", icon: "CreditCard", path: "../admin/plans" },
  { title: "FAQ", desc: "Manage FAQs", icon: "HelpCircle", path: "/admin/faq" },
  { title: "Platform Features", desc: "Feature toggles", icon: "Layers", path: "../admin/platform-features" },
  { title: "Testimonials", desc: "User feedback", icon: "Star", path: "../admin/testimonials" },
  { title: "Stats", desc: "Platform metrics", icon: "BarChart", path: "../admin/stats" }
];

const stats = [
  { label: "Blogs", value: 12 },
  { label: "Plans", value: 4 },
  { label: "Testimonials", value: 18 },
  { label: "FAQs", value: 26 },
];
const AdminDashboard = () => {
  const navigate = useNavigate();

useEffect(() => {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");

  if (!token || !userStr) {
    navigate("/authentication-portal", { replace: true });
    return;
  }

  const user = JSON.parse(userStr);

  if (user.role !== "ADMIN") {
    navigate("/authentication-portal", { replace: true });
  }
}, [navigate]);

  return (
    <div className="min-h-screen bg-background">

      <main className="pt-[60px] px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">Admin Dashboard</h1>
          <p className="text-muted-foreground mb-8">
            Manage platform content and configuration
          </p>

         <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
  {stats.map((s) => (
    <div
      key={s.label}
      className="bg-card border border-border rounded-lg p-4"
    >
      <p className="text-sm text-muted-foreground">{s.label}</p>
      <p className="text-2xl font-bold">{s.value}</p>
    </div>
  ))}
</div>

        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
